<template>
  <button
    @click.prevent="handleClick"
    :disabled="!isInitial"
  >
    <span class="font_icon left fa fa-envelope fa-1x"></span>
    <span class="text">
      Send email to client
    </span>
  </button>
</template>

<script>
const STATE_INITIAL = 0,
  STATE_UPDATING = 1; 

export default {
  name: 'InterfaceEmailClientButton',
  props: {
    postId: Number,
  },
  computed: {
    isInitial: {
        get () {
            return this.currentState === STATE_INITIAL;
        },
    },
    isUpdating: {
        get () {
            return this.currentState === STATE_UPDATING;
        },
    },
  },
  data: function(){
    return {
      currentState: null,
    }
  },
  created: function () {
    console.log("InterfaceEmailClientButton created");
    this.currentState = STATE_INITIAL;
  },
  methods: {
    handleClick() {
      this.send();
    },
    send() {
      this.currentState = STATE_UPDATING;
      const self = this;
      const data = {
        post_id: this.postId,
      }

      this.axios.post(window.baseUrl + 'api/emailclient', data).then(response => {
        // console.log(response.data.responseResult.data);
        console.log(response.data.responseResult);
        // self.notes = response.data.responseResult.data;
        self.onSendComplete();
      });
    },
    onSendComplete() {
      // this.currentState = STATE_INITIAL;
    },
  }
}
</script>
